export const getFilePathFromParams = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  const filePath = params.get('filePath');
  return filePath ? new URL(filePath).href : null;
};
